import {isEqual} from 'lodash';
import {memo} from 'react';
import {EstSalesTopRankItem} from '@/map/@types';
import {Block, IBlockProps} from './Block';

interface IProps extends IBlockProps {
  map: naver.maps.Map;
  items: EstSalesTopRankItem[];
}

export const RankingBlockLayer = memo(
  ({items, ...props}: IProps) => {
    if (!items?.length) {
      return null;
    }

    return (
      <>
        {items.map((i, idx) => (
          <Block key={idx} item={i} rank={idx} {...props} />
        ))}
      </>
    );
  },
  (prev, next) => isEqual(prev, next)
);
